import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { Card, Typography } from "@mui/material";
import { CategoryRevenue } from "../types/dashboardTypes";

interface Props {
  data: CategoryRevenue[];
}

const CategoryRevenueChart = ({ data }: Props) => (
  <Card className="saloon-chart-card">
    <Typography variant="h6" gutterBottom>
      Category Revenue
    </Typography>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <XAxis dataKey="category" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="revenue" fill="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  </Card>
);

export default CategoryRevenueChart;
